import React from "react";
import clsx from "clsx";
import DataTable from "../../DataTable/DataTable";

class RoomPresenterLocks extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "locks",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="locks">
        <div className="row">
          <div className="col-md-3">
            <label>{`${I18n.t("lock_management")}`}</label>{" "}
            <span
              className="ss-help help"
              title={I18n.t("lock_management_helper_text")}
            ></span>
            <br />
            {I18n.t(this.props.room.lock_management)}
          </div>
          {this.renderLockForm()}
        </div>
        {this.renderRoomLocksDataTable()}
      </div>
    );
  }

  renderLockForm() {
    if (this.props.room.lock_management === "manual_key_code") {
      return (
        <div className="col-md-3">
          <label>{`${I18n.t("pin_code")}`}</label>{" "}
          <span
            className="ss-help help"
            title={I18n.t("pin_code_helper_text")}
          ></span>
          <br />
          {this.props.room.pin_code}
        </div>
      );
    } else if (this.props.room.lock_management === "remotelock") {
      const devices = this.props.room.devices.map((device) => {
        return <li key={device.id}>{device.name}</li>;
      });
      return (
        <div className="col-md-3">
          <label>{`${I18n.t("devices")}`}</label>{" "}
          <span
            className="ss-help help"
            title={I18n.t("remotelock_devices_helper_text")}
          ></span>
          <ul>{devices}</ul>
        </div>
      );
    }
  }

  renderRoomLocksDataTable() {
    if (
      this.props.room.lock_management === "remotelock" &&
      this.props.room_locks_endpoint
    ) {
      return (
        <div className="row">
          <div className="col-md-12">
            <hr style={{ marginTop: "2rem" }} />
            <DataTable
              endpoint={this.props.room_locks_endpoint}
              no_data_text={I18n.t("no_lock_history")}
              currency_unit={I18n.t("number.currency.format.unit")}
              delimiter={I18n.t("number.currency.format.delimiter")}
              separator={I18n.t("number.currency.format.separator")}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              model_name={"RoomLock"}
            />
          </div>
        </div>
      );
    }
  }
}
export default RoomPresenterLocks;
